import { TextD2C } from "@/scott/ui/elements/text-d2c/text";
import type { ProductDetailFeatureItem } from "../product-detail-page.adapter";

export interface ProductKeyFeatureListProps {
  features: ProductDetailFeatureItem[];
  limit?: number;
}

export function ProductKeyFeatureList(
  props: Readonly<ProductKeyFeatureListProps>
) {
  const visibleFeatures = props.limit
    ? props.features.slice(0, props.limit)
    : props.features;

  if (visibleFeatures.length === 0) {
    return null;
  }

  return (
    <ul className="space-y-2">
      {visibleFeatures.map((feature, index) => (
        <li key={`${feature.id}-${index}`}>
          <TextD2C style="no-mb" variant="p-small">
            {feature.value}
          </TextD2C>
        </li>
      ))}
    </ul>
  );
}
